<template>
    <div  :style='{width: panelWidth}' >
    <el-table
      class='riskTable'
      :data="data"
      :cell-class-name = "() => 'lu-click'"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='(row, column) => onRowDblClick(row, column)'
    >
    <el-table-column :label='$t("Env")' sortable prop='brokerName' align="left" />
    <el-table-column :label='$t("Account")' sortable prop='accountNumber' align="left" />
      <el-table-column prop='profitAndLoss' :label='$t("Eq to Eq")' sortable :sort-method='(a,b) => sortFloat(a,b,"profitAndLoss")' align='center'>
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.profitAndLoss)'>{{ data.row.profitAndLoss | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop='volume' :label='$t("Volume")' sortable :sort-method='(a,b) => sortFloat(a,b,"volume")' align='center'>
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.volume)'>{{ data.row.volume | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop='cost' :label='$t("Vol Cost")' sortable :sort-method='(a,b) => sortFloat(a,b,"cost")' align='center'>
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.cost)'>{{ data.row.cost | formatAmount(0) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop='pct' :label="$t('NTP %')" sortable :sort-method='(a,b) => sortFloat(a,b,"pct")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.pct | formatPercent }}</div>
        </template>
      </el-table-column>
      <el-table-column prop='profitShare' :label='$t("Profit Share")' sortable :sort-method='(a,b) => sortFloat(a,b,"profitShare")' align='center'>
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.profitShare)'>{{ data.row.profitShare | formatAmount(0) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog class="centered" :append-to-body="false" :modal="false" :title="updateDialogData.title" :visible.sync="showUpdateDialog" @close='cancelUpdateDialog' width="30%">
      <lu-vbox lu-hcenter class='dialog-container'>
        <lu-hbox lu-hcenter lu-flex lu-vcenter class='pad-in-5 mar-t-10'>
          <lu-item lu-vcenter>{{ $t("Value") }}</lu-item>
          <template v-if="updateDialogData.field === 'pct'">
            <lu-item lu-vcenter class='mar-l-10'><el-input-number v-model="updateDialogData.currentValue" :controls="false" controls-position="right" :min="0" :max="100" :precision="0" :step="1" /></lu-item>
          </template>
          <template v-else-if="updateDialogData.field === 'cost'">
            <lu-item lu-vcenter class='mar-l-10'><el-input-number v-model="updateDialogData.currentValue" :controls="false" controls-position="right" :min="0" /></lu-item>
          </template>
        </lu-hbox>
        <lu-hbox lu-hcenter class='pad-in-5' style="margin-top: 30px;">
          <lu-item><el-button @click.native.prevent="validateUpdateDialog">{{ $t('Validate') }}</el-button></lu-item>
          <lu-item><el-button @click.native.prevent="cancelUpdateDialog">{{ $t('Cancel') }}</el-button></lu-item>
        </lu-hbox>
      </lu-vbox>
    </el-dialog>
    <el-dialog class="centered" :append-to-body="false" :modal="false" title="Settings - Client NTP" :visible.sync="showSettingsDialog" @close='cancelSettingsDialog' width="35%">
      <lu-vbox lu-vcenter lu-hcenter lu-flex>
        <el-form :model='settingsDialogData' label-width="150px" lu-flex label-position="left" :rules="settingsDialogRules" ref='settingsForm'>
          <el-form-item label="Env" prop="brokerName" required>
            <el-input v-model="settingsDialogData.brokerName" clearable />
          </el-form-item>
          <el-form-item label="Account" prop="accountNumber" required style="margin-top: 25px;">
            <el-input v-model="settingsDialogData.accountNumber" clearable />
          </el-form-item>
          <el-form-item style="margin-top: 30px; margin-bottom: 0;">
            <lu-hbox lu-hcenter lu-flex class='pad-in-5'>
              <el-button type="primary" @click="validateSettingsDialog('add')">{{ $t('Add') }}</el-button>
              <el-button style="margin-left: 5px" @click="validateSettingsDialog('remove')">{{ $t('Remove') }}</el-button>
            </lu-hbox>
          </el-form-item>
        </el-form>
      </lu-vbox>
    </el-dialog>
  </div>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'NTPLP',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  components: { LuHbox, LuVbox, LuItem },
  data: function () {
    return {
      updateDialogData: {
        field: '',
        currentValue: 0,
        label: '',
        title: '',
        brokerName: '',
        accountNumber: ''
      },
      settingsDialogData: {
        brokerName: '',
        accountNumber: ''
      },
      showUpdateDialog: false,
      showSettingsDialog: false,
      settingsDialogRules: {
        brokerName: [
          { required: true, message: 'Please input env name', trigger: ['blur', 'change'] }
        ],
        accountNumber: [
          { required: true, message: 'Please input account number', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    isSymbolGrpKey: function () {
      //return this.groupKeys[this.panel.options.groupKey] === "symbol"
      return true
    }
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3, false)
    },
    formatRate: function (value, prec) {
      return utils.formatNumber(value || 0, prec)
    },
    formatPercent: function (value) {
      // return value + ' %'
      return utils.formatNumber(value || 0, 0) + ' %'
    }
  },
  methods: {
    onSettings () {
      this.clearSettingsDialog()
      this.showSettingsDialog = true
    },
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'Symbol' : 'Currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]

      if (label === 'Total') return //not an instrument

      // this.$store.dispatch('settingsMonitor/changeDetailParams', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
      this.$emit('getDetail', {title: this.panel.options.title, type: 'flow', value: label, params: params, show: true})
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    onRowDblClick (row, column) {
      if (row && column) {
        if (column.property === 'pct' || column.property === 'cost') {
          this.clearUpdateDialog()
          this.updateDialogData.field = column.property
          this.updateDialogData.currentValue = row[column.property]
          this.updateDialogData.label = column.label
          this.updateDialogData.title = `${this.$t('Update')} ${column.label}`
          this.updateDialogData.brokerName = row.brokerName
          this.updateDialogData.accountNumber = row.accountNumber
          this.showUpdateDialog = true
        }
      }
    },
    validateUpdateDialog() {
      if (!this.updateDialogData.field) return
      const cond = {
        MTI: 4989,
        functionId: 'updNTPClient',
        brokerName: this.updateDialogData.brokerName,
        accountNumber: this.updateDialogData.accountNumber
      }
      cond[this.updateDialogData.field] = this.updateDialogData.currentValue || 0

      this.$tango.request(cond).then(rep => {
        if (rep.resultCode === 0) {
          this.showSettingsDialog = false
          this.$message({
            message: 'Settings Client NTP updated successfully',
            type: 'success'
          })
          this.clearUpdateDialog()
        }
        else {
          this.showSettingsDialog = false
          this.$message({
            message: 'Settings Client NTP validate error',
            type: 'error'
          })
          this.clearUpdateDialog()
        }
      }).catch(() => {
        this.showSettingsDialog = false
        this.clearUpdateDialog()
      })
    },
    clearUpdateDialog() {
      this.showUpdateDialog = false
      this.updateDialogData = {
        field: '',
        currentValue: 0,
        label: '',
        title: '',
        brokerName: '',
        accountNumber: '',
      }
    },
    cancelUpdateDialog() {
      this.clearUpdateDialog()
    },
    clearSettingsDialog() {
      this.showSettingsDialog = false
      this.settingsDialogData = {
        brokerName: '',
        accountNumber: ''
      }
    },
    cancelSettingsDialog() {
      this.clearSettingsDialog()
    },
    validateSettingsDialog (action) {
      this.$refs.settingsForm.validate((valid) => {
        if (valid) {
          this.sendSettingsRequest(action)
        }
      })
    },  
    sendSettingsRequest (action) {
      let api = ''
      if (action === 'add') {
        api = 'addNTPClient'
      }
      else if (action === 'remove') {
        api = 'remNTPClient'
      }
      if (!api || !this.settingsDialogData.brokerName || !this.settingsDialogData.accountNumber) return

      const cond = {
        MTI: 4989,
        functionId: api,
        brokerName: this.settingsDialogData.brokerName,
        accountNumber: this.settingsDialogData.accountNumber
      }

      this.$tango.request(cond).then(rep => {
        if (rep.resultCode === 0) {
          this.showSettingsDialog = false
          this.$message({
            message: 'Client NTP updated successfully',
            type: 'success'
          })
          this.clearSettingsDialog()
        }
        else {
          this.showSettingsDialog = false
          this.$message({
            message: 'Client NTP validate error',
            type: 'error'
          })
          this.clearSettingsDialog()
        }
      }).catch(() => {
        this.showSettingsDialog = false
        this.clearSettingsDialog()
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.inst-container {
  .rowData {
    justify-content: center;
    vertical-align: baseline;
    height: 25px;
    margin: 5px 0;
  }
}
</style>
